import React, { useMemo, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { VisibilityOff as VisibilityOffIcon } from '@mui/icons-material';
import { Category } from '../types/foundObject';
import { DASHBOARD_BRAND_PRIMARY } from '../theme/dashboardBrand';
import { collectSecretAttributeEntries } from '../utils/objectAttributeDisplay';
import { SECRET_OBJECT_ATTRIBUTE_KEY } from '../utils/secretObjectAttributes';

type Props = {
  objectAttributes?: Record<string, unknown> | null;
  category?: Category | null;
  size?: 'small' | 'medium';
};

const FoundObjectSecretDetailButton: React.FC<Props> = ({
  objectAttributes,
  category,
  size = 'small',
}) => {
  const [open, setOpen] = useState(false);
  const entries = useMemo(
    () => collectSecretAttributeEntries(objectAttributes, category),
    [objectAttributes, category]
  );

  return (
    <>
      <Button
        size={size}
        startIcon={<VisibilityOffIcon />}
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
        sx={{
          textTransform: 'none',
          color: DASHBOARD_BRAND_PRIMARY,
          fontWeight: 600,
          '& .MuiButton-startIcon': { color: DASHBOARD_BRAND_PRIMARY },
          '&:hover': { bgcolor: 'rgba(81, 190, 238, 0.08)' },
        }}
      >
        Détail secret
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Détail secret</DialogTitle>
        <DialogContent dividers>
          {entries.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Aucun détail secret renseigné.
            </Typography>
          ) : (
            entries.map(({ key, label, value }, index) => (
              <Box key={key} sx={{ mb: index < entries.length - 1 ? 2 : 0 }}>
                {key !== SECRET_OBJECT_ATTRIBUTE_KEY && (
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                    {label}
                  </Typography>
                )}
                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                  {value}
                </Typography>
              </Box>
            ))
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Fermer</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FoundObjectSecretDetailButton;
